// export const emailReg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export const emailReg = /^([a-zA-Z0-9'`_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,10})$/;

export const alphanumericReg = /[^a-zA-Z0-9]/g;
export const alphanumericUpperCaseReg = /^[A-Z0-9]+$/;

export const lenTokenReg = /^.{15}$/;
export const achRouting = /^\d{9}$/;

export const expirationDate = /^(0[1-9]|1[0-2])([0-9]{2})$/;
export const cvv = /^[0-9]{3,4}$/;

// Then use this regex that matches Visa, MasterCard, American Express, Diners Club, Discover, and JCB cards
export const card =
  /^(?:4[0-9]{12}(?:[0-9]{3})?(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;
export const amexCard = /^3[47][0-9]{13}$/;
export const potentialAmex = /^3[47]/;
export const cardCodeThreeSymbolReg = /^[0-9]{3}$/;
export const cardCodeFourSymbolReg = /^[0-9]{4}$/;

export const visaCardNumberReg = /^4/;
export const masterCardNumberReg = /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/;
export const amexCardNumberReg = /^3[47]/;
export const discoverCardNumberReg = /^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)/;
export const jcbCardNumberReg = /^35(2[89]|[3-8][0-9])/;
export const optimisticCardNumber = /^\*{12}\d{4}$/;
export const optimisticBankAccount = /^\*{5}\d{4}$/;

export const arrowReg = /<[^>]+>|\\n+/g;
export const userNameReg = /^[a-zA-Z0-9_\-.@]*$/g;
export const passwordReg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[-!#$%()*+,.:;=?@[\\\]_{|}~]).{12,50}$/g;

export const phoneReg = /^[0-9]{3,3}-[0-9]{3,3}-[0-9]{4,4}$/g;

export const postalReg = /^[A-Za-z0-9 -]{1,9}$/;
export const amountReg = /^(0|[1-9]\d*)(\.\d+)?$/;
export const withoutSpaceReg = /^[^\s]+$/;
export const numberReg = /^[0-9]+$/;
export const numberWithDecimalReg = /^[0-9]+(\.[0-9]{1,2})?$/;
export const numberWithDecimalRegNegative = /^-?[0-9]+(\.[0-9]{1,2})?$/;
export const numberStartOneReg = /^[0-9]+$/;

export const filenameReg = /filename=([^;]+)*/i;
export const filenameNACHAReg = /^([a-zA-Z0-9_\- .()[\]&$!#*%@=+{}]+)\.([a-zA-Z0-9_-]{1,10})$/;

export const camelToFlat = (value: string): string => {
  const string = value.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  return string
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(' ');
};

export const reservedFieldReg = /^(?![xX][mM][lL])(?!(guid)$)[a-zA-Z_][a-zA-Z0-9_.-]*$/;
export const customValueNameFieldReg = /^[a-zA-Z_][a-zA-Z0-9_.-]*$/;

export const firstLastNameReg = /^[A-Za-z0-9 .,&'`~-]*$/;

export const normalHex = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i;
export const shortHex = /^#([0-9a-f])([0-9a-f])([0-9a-f])$/i;
